import { TextField } from "@material-ui/core";
import CheckboxWithLabel from "../CheckboxWithLabel";
import { KeyboardDatePicker } from "@material-ui/pickers";
import ToggleButtons from "./ToggleButtons";
import { useState } from "react";
import GenderAutocomplete from "./GenderAutocomplete";
import TooltipIcon from "../TooltipIcon/TooltipIcon";
const _spacing = "10px";

const DqForm = props => {
  const handleChange = e => {
    let value;
    let name;
    if (e.target.type === "checkbox") {
      value = e.target.checked;
      name = e.target.value;
    } else {
      name = e.target.name;
      value = e.target.value;
    }
    props.setQueryState(prevState => {
      return { ...prevState, [name]: value };
    });
  };

  const handleDateChange = (date, str) => {
    props.setQueryState(prevState => {
      return { ...prevState, dob: str };
    });
  };
  const [toggleOption, setToggleOption] = useState(0);

  const NameDob = () => {
    return (
      <>
        {/* eslint-disable-next-line jsx-a11y/no-autofocus -- Focus Name when the Name/DOB query form opens. */}
        <TextField autoFocus
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          margin="dense"
          id="name-id"
          label="Name"
          helperText={"Last Name, First Name Middle Initial"}
          value={props?.queryState?.name || ""}
          onChange={handleChange}
          name="name"
          style={{ width: "45%" }}
        />
        <KeyboardDatePicker
          data-testid="dob"
          inputProps={{ "data-testid": "dob-input" }}
          autoOk
          variant="inline"
          inputVariant="outlined"
          label="Date of birth"
          value={props?.queryState?.dob || null}
          onChange={(date, str) => handleDateChange(date, str)}
          format="YYYYMMDD"
          helperText={"Date format: YYYYMMDD"}
          disableFuture={true}
          style={{ width: "45%" }}
        />
        <GenderAutocomplete
          value={props?.queryState?.gender}
          handleChange={handleChange}
        />
      </>
    );
  };

  const Oln = () => {
    return (
      <TextField
        variant="outlined"
        inputProps={{ "data-cy": "oln-input" }}
        InputLabelProps={{ shrink: true, "data-cy": "oln-input-label" }}
        margin="dense"
        id="oln-id"
        label="Operator's License Number"
        value={props?.queryState?.oln || ""}
        onChange={handleChange}
        name="oln"
        style={{ width: "45%" }}
      />
    );
  };

  const formOptions = [NameDob, Oln];
  return (
    <div
      data-testid="dq-form"
      id="bottom-half"
      style={{ display: "flex", flexDirection: "column", rowGap: "10px" }}
    >
      {props.children}
      <ToggleButtons
        buttons={[{ name: "Name/DOB" }, { name: "OLN" }]}
        callback={setToggleOption}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        {formOptions[toggleOption] && formOptions[toggleOption]()}
      </div>
      <div style={{ display: "flex", alignItems: "center", columnGap: "5px" }}>
        <p style={{ fontWeight: "bold", margin: 0 }}>Conditional Fields</p>
        <TooltipIcon
          hoverText="These fields may be required or not allowed"
          text="These fields may be required or not allowed based on the state selected in the Destination field above. Refer to the state-specific guidelines from NLETs for more information."
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "wrap",
          border: "1px solid black",
          justifyContent: "space-between",
          padding: _spacing,
        }}
      >
        <CheckboxWithLabel
          formStyle={""}
          checked={props?.queryState?.imq}
          onChange={handleChange}
          stateName={"imq"}
          title={"License Photo (Optional)"}
          canEdit={true}
        />
      </div>
    </div>
  );
};

export default DqForm;
